import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Box, CssBaseline, ThemeProvider, Drawer, useMediaQuery, useTheme, Toolbar } from '@mui/material';
import SideBar from './Components/Bars/SideBar';
import TopNavBar from './Components/Bars/TopNavBar';
import DashBoardRoutes from './Routes/DashBoardRoutes';
import Breadcrumbs from './Components/Navigation/Breadcrumbs';
import Login from './Components/Auth/Login';
import { PermissionProvider } from "./context/PermissionContext";
import { UserProvider } from "./context/UserContext";
import { GlobalSnackbarProvider } from './Components/Common/GlobalSanckbar';
import { NavbarVisibilityProvider } from './context/NavbarVisibilityContext';
import './App.css';
import theme from './Theme/theme';

function App() {
  const [sidebarWidth, setSidebarWidth] = useState(240);
  const [mobileOpen, setMobileOpen] = useState(false);
  const muiTheme = useTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down('md'));

  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return localStorage.getItem('isAuthenticated') === 'true';
  });

  const handleLogin = () => {
    setIsAuthenticated(true);
    localStorage.setItem('isAuthenticated', 'true');
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    localStorage.clear(); // Clear all stored data including tokens and role info
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  if (!isAuthenticated) {
    return (
      <UserProvider isAuthenticated={isAuthenticated}>
        <PermissionProvider>
          <GlobalSnackbarProvider>
            <ThemeProvider theme={theme}>
              <CssBaseline />
              <Router>
                <Routes>
                  <Route path="/" element={<Login onLogin={handleLogin} />} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </Router>
            </ThemeProvider>
          </GlobalSnackbarProvider>
        </PermissionProvider>
      </UserProvider>
    );
  }

  return (
    <UserProvider isAuthenticated={isAuthenticated}>
      <PermissionProvider>
        <GlobalSnackbarProvider>
          <NavbarVisibilityProvider>
            <Router>
              <ThemeProvider theme={theme}>
                <CssBaseline />
                <Box sx={{ display: 'flex' }}>
                  <TopNavBar onMenuClick={handleDrawerToggle} sidebarWidth={isMobile ? 0 : sidebarWidth} />

                {/* Sidebar with Drawer for responsive behavior */}
                <Box
                  component="nav"
                  sx={{ width: { md: sidebarWidth }, flexShrink: { md: 0 } }}
                >
                  <Drawer
                    variant={isMobile ? "temporary" : "permanent"}
                    open={isMobile ? mobileOpen : true}
                    onClose={handleDrawerToggle}
                    ModalProps={{
                      keepMounted: true, // Better open performance on mobile.
                    }}
                    sx={{
                      '& .MuiDrawer-paper': {
                        boxSizing: 'border-box',
                        width: sidebarWidth,
                        borderRight: '1px solid #E8E8E8',
                        overflow: 'hidden',
                        transition: muiTheme.transitions.create('width', {
                          easing: muiTheme.transitions.easing.sharp,
                          duration: muiTheme.transitions.duration.enteringScreen,
                        })
                      },
                    }}
                  >
                    <SideBar setSidebarWidth={setSidebarWidth} onLogout={handleLogout} onClose={isMobile ? handleDrawerToggle : undefined} />
                  </Drawer>
                </Box>

                <Box
                  component="main"
                  sx={{
                    flexGrow: 1,
                    p: 3,
                    bgcolor: '#F8F9FA',
                    minHeight: '100vh',
                    width: { md: `calc(100% - ${sidebarWidth}px)` },
                    minWidth: 0,
                    transition: muiTheme.transitions.create(['margin', 'width'], {
                      easing: muiTheme.transitions.easing.sharp,
                      duration: muiTheme.transitions.duration.leavingScreen,
                    }),
                  }}
                >
                  <Toolbar /> {/* Spacer for TopNavBar */}
                  <Breadcrumbs />
                  <DashBoardRoutes />
                </Box>
              </Box>
            </ThemeProvider>
          </Router>
          </NavbarVisibilityProvider>
        </GlobalSnackbarProvider>
      </PermissionProvider>
    </UserProvider>
  );
}

export default App;
/* test staging 1783018435 */
/* staging test 1783019510 */
/* admin staging api fix 1783057430 */
